import { roles } from "../config/roles";
import Storage from "./AsyncStorage";

export const checkRouteName = (route) => {
  // const role = localStorage.getItem("role");
  const role = Storage.getERole("@role");

  const routes = route.split("/");
  if (
    routes[0] == "clientHome" ||
    routes[0] == "guestHome" ||
    routes[0] == "vendorHome"
  )
    return "Home";
  if (routes[0] == "events" || routes[0] == "guestEvents") return "Events";
  if (routes[0] == "profile") return "Profile";
  if (routes[0] == "editprofile") return "Edit Profile";
  if (routes[0] == "customerCleaner") return "Cleaners";
  if (routes[0] != null)
    return (
      routes[0][0].toUpperCase() +
      routes[0]
        .slice(1)
        .replace(/([A-Z])/g, " $1")
        .trim()
    );
  return null;
};
export const redirect_uri = () => {
  // const uri = 'http://127.0.0.1:8000/';
  const uri = 'https://bestdayever-web.web.app/';
  console.log('uri',uri)
  return uri;
}


export const headers = {
  config: async () => {
    let token = await Storage.getToken();
    return {
      // timeout: 5000,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Content-Type": "multipart/form-data",
        // "Content-Length": 10967,
        Authorization: `Bearer ${token}`,
      },
    };
  },
  configRNFetch: async () => {
    let token = await Storage.getToken();
    return {
      // timeout: 5000,
      headers: {
        Accept: "*/*",
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    };
  },
  configSpotify: async () => {
    const token = localStorage.getItem('access_token');
    console.log("configSpotify============token", token);
    // let token = await Storage.getSpotifyTokens();
    // let parseData = JSON.parse(token)
    return {
      // timeout: 5000,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
  },
};

export const GlobalDebug = (function () {
  var savedConsole = console;
  /**
   * @param {boolean} debugOn
   * @param {boolean} suppressAll
   */
  return function (debugOn, suppressAll) {
    var suppress = suppressAll || false;
    if (debugOn === false) {
      // supress the default console functionality
      // console = {};
      console.log = function () { };
      // supress all type of consoles
      if (suppress) {
        console.info = function () { };
        console.warn = function () { };
        console.error = function () { };
      } else {
        console.info = savedConsole.info;
        console.warn = savedConsole.warn;
        console.error = savedConsole.error;
      }
    } else {
      console = savedConsole;
    }
  };
})();
export const phoneFormat = (text) => {
  var cleaned = ("" + text).replace(/\D/g, "");
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    var intlCode = match[1] ? "+1 " : "",
      number = [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join(
        ""
      );
    return number;
  }
  return text;
};
